import { combineReducers } from "redux"

import OneFleetEntregaDevolucao from "./onefleetdevolucao"
import OneFleetEntregaReducer from "./onefleetentrega"

export default combineReducers({
  onefleetentrega: OneFleetEntregaReducer,
  onefleetdevolucao: OneFleetEntregaDevolucao
})
